import styled, { css } from 'styled-components'
import { IBiRadsBadgeProps } from '.'

const getColor = (category: number) => {
  switch (category) {
    case 1:
    case 2:
      return '#12893A'
    case 3:
      return '#F5D06C'
    case 4:
    case 5:
    default:
      return '#D93B2A'
  }
}

const fontStyleBy = (size: IBiRadsBadgeProps['size']) => {
  switch (size) {
    case 'sm':
      return css`
        font-size: 10px;
        font-weight: 600;
      `
    case 'md':
    default:
      return css`
        font-size: 12px;
        font-weight: 600;
      `
  }
}

export const Badge = styled.div<IBiRadsBadgeProps>`
  color: #fff;
  background-color: ${props => getColor(props.category)};
  border-radius: 24px;
  padding: 4px 8px;
  ${props => fontStyleBy(props.size)}
  text-transform: uppercase;
`
